import { styled } from 'linaria/react';
import React from 'react';
import { CornerBorder } from '../../../CornerBorder/CornerBorder';
import { muiTheme, theme } from '../../../Theme/Theme';
import { HeadingFour } from '../../../Typography/HeadingFour/HeadingFour';

export interface TrainingPlaceHeaderProps {
  className?: string;
  name: string;
  address: string;
}

const TrainingPlaceHeaderInner = (props: TrainingPlaceHeaderProps) => {
  const { name, address } = props;
  return (
    <div className={props.className}>
      <CornerBorder className="cb--top cb--right cb--secondary" />
      <HeadingFour className="day">{name}</HeadingFour>
      <p className="place-address">{address}</p>
      <CornerBorder className="cb--bottom cb--left cb--secondary" />
    </div>
  );
};

export const TrainingPlaceHeader = styled(TrainingPlaceHeaderInner)`
  position: relative;
  height: 170px;
  text-align: center;
  max-width: 220px;
  margin: auto;
  font-size: 2rem;
  color: ${theme.color.primary};
  font-weight: 500;
  display: flex;
  align-items: center;
  flex-flow: column;
  justify-content: center;

  .place-address {
    width: 90%;
  }

  .day {
    padding: 0px 0 16px 0px;
  }

  ${muiTheme.breakpoints.down('sm')} {
    max-width: unset;
  }
`;
